module.exports = __webpack_public_path__ + "media/press/bla3-3efc3f96.png";